function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 2.5C8.1125 2.5 2.5 8.1 2.5 15C2.5 21.8875 8.1125 27.5 15 27.5C21.9 27.5 27.5 21.8875 27.5 15C27.5 8.21695 22.0882 2.6902 15.3497 2.50481L15 2.5Z",
  fill: "#DEE8F3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.9041 12.1989L17.925 9.10519C17.8278 9.0044 17.6788 8.97276 17.5492 9.02496C17.419 9.07766 17.3337 9.20371 17.3337 9.34395V10.8336H17.2192C14.7552 10.8336 12.7505 12.8383 12.7505 15.3023V15.9898C12.7505 16.1492 12.8628 16.2821 13.0181 16.3184C13.0434 16.3248 13.0686 16.3276 13.0937 16.3276C13.2235 16.3276 13.3477 16.2514 13.4077 16.1318C14.0521 14.8425 15.3478 14.0418 16.7893 14.0418H17.3337V15.5314C17.3337 15.6717 17.419 15.7977 17.5492 15.8499C17.678 15.9027 17.8278 15.8706 17.925 15.7697L20.9041 12.676C21.0325 12.5427 21.0325 12.3328 20.9041 12.1989Z",
  fill: "#7E8897"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6249 20H11.375C10.6169 20 10 19.3832 10 18.625V12.2085C10 11.4504 10.6169 10.8335 11.375 10.8335H12.75C13.0034 10.8335 13.2083 11.0384 13.2083 11.2918C13.2083 11.5452 13.0034 11.7501 12.75 11.7501H11.375C11.122 11.7501 10.9166 11.9555 10.9166 12.2085V18.625C10.9166 18.878 11.122 19.0834 11.375 19.0834H19.6249C19.8778 19.0834 20.0832 18.878 20.0832 18.625V14.9584C20.0832 14.705 20.288 14.5001 20.5415 14.5001C20.795 14.5001 20.9999 14.705 20.9999 14.9584V18.625C20.9999 19.3832 20.383 20 19.6249 20Z",
  fill: "#7E8897"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  fill: "white",
  transform: "translate(10 9)"
})));

function SvgMobileShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileShare);
export default __webpack_public_path__ + "static/media/MobileShare.0ba1fd5f.svg";
export { ForwardRef as ReactComponent };